import { Component } from 'react';
import styled, { css } from 'styled-components';
import { adFeedStyle, adPlainStyle } from '../../css/setting/adStyle';

/* インフィード広告は全てのページで、上罫線が常につく　*/
const ListItem = styled.li<{ $isShowAd: boolean }>(
  ({ $isShowAd }) => css`
    visibility: ${$isShowAd ? 'visible' : 'hidden'};
    border-top: 1px solid ${props => props.theme.news.palette.bor_lv1_pc};
  `
);

const AdItem = styled.div`
  ${adPlainStyle}
  ${adFeedStyle}
  
  border-bottom: 1px solid ${props => props.theme.news.palette.bor_lv1_pc};
  /* 広告の中身が空の時に罫線が被るのを防ぐ */
  &:empty {
    margin-top: -1px;
  }
`;

interface IProps {
  yadsAdDsId: string;
  itemNumber: number;
  yadsTypeTag?: string;
  shannonId?: string;
  categoryId: string;
  isShowAd?: boolean;
}

/**
 * @deprecated インフィード広告用component
 */
export default class FeedAdItem extends Component<IProps> {
  public componentDidMount() {
    if (!window.ytManager && window.YadsTimelineManager) {
      window.ytManager = new window.YadsTimelineManager({
        yads_ad_ds: this.props.yadsAdDsId,
        yads_bucket_id: window.miffy_bucket_id || '',
        yads_type_tag: window.miffy_type_tag || this.props.yadsTypeTag || '',
        yads_shannon_id: this.props.shannonId,
        yads_placement_category_id: this.props.categoryId
      });
    }
    if (window.ytManager) {
      window.ytManager.insertAd(`ad${this.props.itemNumber}`);
    }
  }
  public render() {
    return (
      <ListItem $isShowAd={this.props.isShowAd ?? true}>
        <AdItem id={`ad${this.props.itemNumber}`} />
      </ListItem>
    );
  }
}
